<template>
  <div class="gw-comments-wrapper">
    <p v-if="!comments.length" class="gw-comments-wrapper__no-comment">{{ $t('message.GW_NO_STEP_COMMENT') }}</p>
    <GwComment
      v-for="(comment, comIndex) in comments"
      :key="comment.id"
      :comment="comment"
      :pb-button="pbButton"
      :disabled="disabled"
      @edit="editComment(comment)"
      @delete="deleteComment(comIndex, comment)"
      @editPictures="editPictures(comment)"
      @textareaAutoSize="$emit('input', comments)"
    />

    <button
      v-if="!disabled"
      class="generic-border generic-border--text-btn generic-border--gray-border"
      @click="addComment"
    >
      <div class="generic-border__left">
        <Icon class="generic-border__left-blue-icon">{{ addExtraBold }}</Icon>
        <span>{{ $t('message.GW_ADD_COMMENT') }}</span>
      </div>
      <Icon class="generic-border__right-arrow">{{ arrowDownLine }}</Icon>
    </button>

    <!-- Hidden components -->
    <FileViewer
      v-if="filesHolder"
      ref="fileViewer"
      v-model="filesHolder.files"
      :editable="!disabled"
      :index="fileViewerIndex"
      pathname="gwComments/"
      @input="editComment(filesHolder)"
      @close="filesHolder = null"
    />
  </div>
</template>

<script>
/**
 * Comment used in field tours to display and manage steps' comments.
 * Allows creating, updating and deleting comments.
 */

// Components
import FileViewer from '@/components/file-system/file-viewer.vue';
import GwComment from '@/components/gw-comment.vue';
import Icon from '@/components/icon.vue';
// Import utils
import { addExtraBold, arrowDownLine } from '@/assets/icons';

export default {

  name: 'GwCommentsWrapper',

  components: {
    FileViewer,
    GwComment,
    Icon,
  },

  props: {
    gw: {
      type: Object,
      required: true,
    },
    pbButton: Boolean,
    comments: {
      type: Array,
      required: true,
    },
    stepId: {
      type: Number,
      required: true,
    },
    disabled: Boolean,
  },

  data() {
    return {
      addExtraBold,
      arrowDownLine,
      filesHolder: null,
      fileViewerIndex: 0,
    };
  },

  methods: {
    addComment() {
      this.$http.post('/server/gembaWalks/addComment.php', { id: this.gw.id, stepId: this.stepId })
        .then((response) => {
          if (response && response.data instanceof Array) {
            this.$emit('input', response.data);
          }
        });
    },
    editComment(com) {
      this.$http.post('/server/gembaWalks/editComment.php', {
        id: this.gw.id,
        stepId: this.stepId,
        comId: com.id,
        text: com.text,
        files: com.files,
      })
        .then((response) => {
          if (response && response.data instanceof Array) {
            this.$emit('input', response.data);
          }
        });
    },
    deleteComment(comIndex, com) {
      this.$http.post('/server/gembaWalks/deleteComment.php', { gwId: this.gw.id, id: com.id })
        .then((response) => {
          if (response && response.data instanceof Array) {
            this.$emit('input', response.data);
          }
        });
    },
    editPictures(comment) {
      this.filesHolder = comment;
    },
  },

};
</script>

<style lang="scss" scoped>
.gw-comments-wrapper {

  &__no-comment {
    margin-left: 10px;
    margin-bottom: 20px;
  }

  &__add-comment {
    width: max-content;
    padding: 10px;
    margin-top: 30px;
  }
}
</style>
